export default function PHP_umask() {
  return (
    <div>
      <h1>PHP_umask</h1>
    </div>
  );
}
